import { IconDimension, IconDimensions } from "../components/types";

export const getIconDimensions = (
  size: IconDimension,
  width: IconDimension,
  height: IconDimension,
  viewBoxWidth: IconDimension,
  viewBoxHeight: IconDimension
): IconDimensions => {
  return {
    width:
      width === undefined && height === undefined && size === undefined
        ? viewBoxWidth
        : width === undefined && height === undefined && size !== undefined
        ? size
        : width,
    height:
      width === undefined && height === undefined && size === undefined
        ? viewBoxHeight
        : width === undefined && height === undefined && size !== undefined
        ? size
        : height,
  };
};
